import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

/**
 * Service to call HTTP request via Axios
 */
const SwfApiService = {
  URL: '',
  API_SWF: 'api/shopping-with-friends',
  async init() {
    Vue.use(VueAxios, axios);
    const resp = await Vue.axios.get(`api/url/get-base-uri`);
    this.URL = resp.data;
  },

  query(resource, params) {
    let config = {
      params
    };

    return Vue.axios.get(this.URL + this.API_SWF + resource, config).catch(error => {
      // console.log(error);
      throw new Error(`[KT] SwfApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  async get(resource, slug = '') {
    return Vue.axios.get(this.URL + `${resource}/${slug}`).catch(error => {
      throw new Error(`[KT] SwfApiService ${error}`);
    });
  },

  getFile(resource, slug = '') {
    return Vue.axios
      .get(this.URL + `${resource}/${slug}`, {
        responseType: 'blob'
      })
      .catch(error => {
        throw new Error(`[KT] SwfApiService ${error}`);
      });
  },
  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */ post(resource, params) {
    return Vue.axios.post(this.URL + this.API_SWF + `${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(this.URL + `${resource}/${slug}`, params);
  },

  patch(resource, params) {
    return Vue.axios.patch(this.URL + `${resource}`, params, {
      headers: { 'Content-Type': 'application/json-patch+json' }
    });
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(this.URL + `${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(this.URL + resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] SwfApiService ${error}`);
    });
  },

  /**
   * Accept shop
   * @param resource
   * @param params
   * @returns {*}
   */ shopAccept(resource, params) {
    return Vue.axios.post(this.URL + this.API_SWF + '/accept', resource, {
      params
    });
  },

  /**
   * Reject shop
   * @param resource
   * @param params
   * @returns {*}
   */ shopReject(resource, params) {
    return Vue.axios.post(this.URL + this.API_SWF + '/reject', resource, {
      params
    });
  },

  /**
   * Manually enrich
   * @param resource
   * @param params
   * @returns {*}
   */ swfEnrich(resource, params) {
    return Vue.axios.post(this.URL + this.API_SWF + '/test/swfenrich', resource, {
      params
    });
  }
};

export default SwfApiService;
